import moment from 'moment';
import { rem } from 'polished';
import React, { Component } from 'react';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import styled from 'styled-components';
import Checkbox from '../../components/Checkbox';
import FormGroup from '../../components/FormGroup';
import Icon from '../../components/Icon';
import Label from '../../components/Label';
import Select from '../../components/Select';
import { __ } from '../../utilities';
import DateWrapper from './../ConnectionForm/DateWrapper';

const CheckBoxWrapper = styled.div`
  margin-left: ${rem(5)};
  margin-top: ${rem(45)};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Col = styled.div`
  display: flex;
  padding: 0 ${rem(5)};
  min-width: 300px;
  flex: 1 0 0;
`;

const Submit = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.darkerPrimary};
  width: 100%;
  height: ${rem(54)};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-top: ${rem(7)};
  margin-bottom: 1.25rem;
  ${({ theme }) => theme.media.sm`  
    margin-bottom: 0;
  `};

  &:hover {
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  }
`;

const StyledSelect = styled(Select)`
  padding: 0px 1.25rem !important;
  padding-right: 3.125rem !important;
  ${({ theme }) => theme.media.lg`
    padding: 0px 1.25rem !important;
    padding-right: 3.125rem !important;
  `};
`;

const StyledLabel = styled(Label)`
  display: inline-block;
  margin-bottom: 10px;
  font-size: 1.125em;
  font-weight: 700;
`;

class CustomForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
    };
  }

  render() {
    const {
      value: {
        count,
        ticketType,
        stationFrom,
        stationTo,
        direct,
        startDate,
        endDate,
      },
      isFetchingEntryStations,
      entryStations,
      isFetchingToStations,
      toStations,
      ticketTypes,
      passengers,
      handleChangeSelect,
      handleDatesChange,
      handleDateChange,
      isOutsideRange,
      onSubmit,
      toogleCheckbox,
    } = this.props;
    const isMobile = window.innerWidth < 800;
    const calendarOptions = {};
    if (isMobile) {
      calendarOptions.orientation = 'vertical';
    }
    return (
      <React.Fragment>
        <Row>
          <Col>
            <FormGroup>
              <StyledLabel>{__('Typ lístka')}</StyledLabel>
              <Select
                value={ticketType}
                name="ticketType"
                onChange={handleChangeSelect}
                options={ticketTypes}
                disabled={ticketType === 'B'}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <StyledLabel>{__('Cestujúci')}</StyledLabel>
              <StyledSelect
                value={count}
                name="count"
                onChange={handleChangeSelect}
                options={passengers}
                disabled={ticketType === 'B'}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <StyledLabel>{__('Nástupná zastávka')}</StyledLabel>
              <Select
                isFetching={isFetchingEntryStations}
                leftIcon="bus-arrow-out"
                value={stationFrom}
                name="stationFrom"
                disabled={ticketType === 'B'}
                onChange={handleChangeSelect}
                options={[
                  { value: '', label: __('Vyberte') },
                  ...entryStations,
                ]}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <StyledLabel>{__('Výstupná zastávka')}</StyledLabel>
              <Select
                leftIcon="bus-arrow-in"
                isFetching={isFetchingToStations}
                value={stationTo}
                name="stationTo"
                disabled={stationFrom === '' || ticketType === 'B'}
                onChange={handleChangeSelect}
                options={[{ value: '', label: __('Vyberte') }, ...toStations]}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <StyledLabel>{__('Dátum cesty')}</StyledLabel>
              <div>
                {ticketType === 'R' ? (
                  <DateWrapper>
                    <label>
                      <DateRangePicker
                        startDatePlaceholderText={__('Dátum prvej cesty')}
                        endDatePlaceholderText={__('Dátum druhej cesty')}
                        startDateId="1"
                        endDateId="2"
                        minimumNights={0}
                        startDate={startDate ? moment(startDate) : null}
                        endDate={endDate ? moment(endDate) : null}
                        onDatesChange={handleDatesChange}
                        focusedInput={this.state.focusedInput}
                        onFocusChange={focusedInput => {
                          this.setState({ focusedInput });
                        }}
                        {...calendarOptions}
                      />
                    </label>
                  </DateWrapper>
                ) : (
                  <DateWrapper>
                    <label>
                      <SingleDatePicker
                        placeholder={__('Zadajte dátum')}
                        isOutsideRange={isOutsideRange}
                        displayFormat="DD.MM.YYYY"
                        date={startDate ? moment(startDate) : null}
                        onDateChange={handleDateChange}
                        focused={this.state.focusedInput}
                        onFocusChange={({ focused }) =>
                          this.setState({ focusedInput: focused })
                        }
                        {...calendarOptions}
                      />
                    </label>
                  </DateWrapper>
                )}
              </div>
            </FormGroup>
          </Col>
          <Col>
            <CheckBoxWrapper>
              <FormGroup>
                <StyledLabel>
                  <Checkbox
                    checked={direct === '1'}
                    onChange={toogleCheckbox}
                  />
                  {__('Zobraziť iba priame spojenia')}
                </StyledLabel>
              </FormGroup>
            </CheckBoxWrapper>
          </Col>
          <Col>
            <Submit onClick={onSubmit}>
              <Icon name="magnify" color="white" />
              &nbsp;
              {__('Vyhľadať spojenie')}
            </Submit>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default CustomForm;



// WEBPACK FOOTER //
// ./src/containers/ExternalConnectionForm/CustomForm.js